import { createAction } from "redux-actions";

export const setStatuses = createAction("SET_STATUSES");